import React, { useEffect, useState } from 'react'

import Header from '../Core/Header'
import { patient } from '../../Assets/dummyPatient'
import { motion } from 'motion/react'
import Cookies from "js-cookie";
import { getPatientMapped, patientMapCheck, sendOtpPatientMapping, uploadReportByDoc, verifyOtpPatientMapping } from '../../service/operations/api_methods';
import { baseURL } from '../../service/api_endpoints';
import { logDOM } from '@testing-library/dom';
import { toast } from 'sonner';

const fileData=[
  {
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },
  {
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },{
    doc:"Dr.Ramendra Trivedi",
    date:"2025-09-16",
  },
]

const Patient = () => {
  const[list,setList]=useState([])
  const[verified,setVerified]=useState(false)
  const[searchKey,setSearchKey]=useState("")
  const [currentUserId,setCurrentUserId]=useState("")
  const[currentUser,setCurrentUser]=useState(null)
  const [link,setLink]=useState(null)
  let item1={
     name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]
  }
  const [modal,setModal]=useState(false)
  const [linkModal,setLinkModal]=useState(false)
  const[otp,setOtp]=useState("")
  const token = Cookies.get("token")

  const[report_type,setReport_type]=useState("")
  const[report_date,setReport_date]=useState("")
  const[report_summary,setReport_summary]=useState("")
  const[report_file,setReport_file]=useState(null)

  const handleGetMappedpatient=async()=>{
    try {
      const res=await getPatientMapped(token)
      console.log(res.data.data);
      if(res.status===200){
        setList(res.data.data)
      }
      
    } catch (error) {
      console.log(error);
      
    }
  }

const handleCheckPatientmap=async(e)=>{
  e.preventDefault()
  let l=[]
  let data={
    aadhaar_id:searchKey,
    token
  }
  try {
    const res=await patientMapCheck(data)
    console.log(res);
    if(res.status===200){
      setLink(res.data.action)
      l.push(res.data.data)
      setList(l)
    }
    
  } catch (error) {
    console.log(error);
    
  }
}

const handleSendOtpPatientMap=async(id)=>{
  console.log(id);
  
  let data={
    token,
    id
  }
  setCurrentUserId(id)
  try {
    const res=await sendOtpPatientMapping(data)
    console.log(res);
    if(res.status===200){
     // setModal(true)
     setLinkModal(true)
    }
    
  } catch (error) {
    console.log(error);
    
  }
}

const handleCreateMapping=async()=>{ /// verify otp to create mapping
  let data={
    token,
    otp,
    id:currentUserId
  }
  try {
    const res=await verifyOtpPatientMapping(data)
    console.log(res);
    if(res.status===200){
      
      handleGetMappedpatient()
      toast.success("Patient linked");
      setOtp("")

    }
    
  } catch (error) {
    console.log(error);
    
  }
}

const handleUploadReport=async()=>{
  const data =
  {token,user_id:currentUser.id,
    report_type,report_date,
    uploaded_person_name:currentUser.first_name,
    report_summary,report_file}

    if(report_date==="" ||report_file===null||report_summary===""||report_type===""){
      toast.info("Fill the report values")
      return
    }
  try {
    const res=await uploadReportByDoc(data)
    console.log(res);
    
    if(res.status===200){
      setReport_date("")
      setReport_file(null)
      setReport_summary("")
      setReport_type("")
      toast.success('Report uploaded Successfully')
    }
  } catch (error) {
    console.log(error);
    
  }
}


useEffect(() => {
  handleGetMappedpatient()
 
}, [])



  return (
    <div style={{height:"100vh",width:"100%"}}>
      <Header/>
      <section style={{marginTop:"80px",height:"calc(100vh - 80px)",background: "linear-gradient(180deg, #555454ff, #ffffffff, #5f5f5fff)",padding:"20px",
        transition: "0.3s ease",filter: modal ? "blur(8px)" : "none", pointerEvents: modal ? "none" : "auto",
      }}>
        <div style={{fontSize:"24px",fontWeight:"700",textAlign:"center",display:"flex",justifyContent:"space-around",padding:"6px"}}>
            <p style={{color:"white"}}>All Patients of this Hospital</p>
           <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:"20px"}}>
            <input placeholder='Search Patient with Aadhar Number'
            style={{border:"0.5px solid white",
                borderRadius:"8px",
                fontSize:"16px",padding:"5px",
                backgroundColor:"white",
                width:"fit-content"
            }}
            value={searchKey}
            onChange={(e)=>setSearchKey(e.target.value)}
            />
            <p onClick={handleCheckPatientmap}
            style={{fontSize:"14px",fontWeight:500,cursor:"pointer",
              padding:"8px",borderRadius:"8px",backgroundColor:"#328bffff",color:"white"
            }}>Search</p>
            </div> 

            </div>
        <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"100%",overflowY:"auto",overflowX:"hidden"}}>
            {list.length>0 &&
            list.length===1?
              list.map((item)=>(
                <div style={{width:"22vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>
                    <img src={'http://192.168.29.250:7003'+`${item.profile_image}`} style={{height:"70%",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item.first_name}{"  "}{item.last_name}</p>
                        
                       
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Contact:{item.primary_number}</p>
                       
                      <p style={{fontSize:"14px",fontWeight:"800"}}>{item.email}</p>
                      {linkModal &&<div style={{display:"flex",alignItems:"center",flexDirection:"column",justifyContent:"left",gap:"20px",padding:"2px 20px",backgroundColor:"#fccfb0ff",borderRadius:"6px"}}>
            <p style={{fontSize:"10px"}}>Otp sent to patient's email</p>
            <input style={{border:"1px solid gray",borderRadius:"5px",outline:"none",fontSize:"8px",padding:"3px"}}
            placeholder='Enter OTP'
            value={otp} onChange={(e)=>setOtp(e.target.value)}/>
            <p onClick={handleCreateMapping}
            style={{cursor:"pointer",padding:"7px",borderRadius:"5px",backgroundColor:"#5b8fffff",fontSize:"12px",fontWeight:"700",color:"white"}}>verify</p>
                       </div>}
                         
                     </div>

                    {link==='LINK_FIRST'&& <div onClick={()=>handleSendOtpPatientMap(item.user_id)}
                     style={{display:"flex",alignItems:"center",padding:"3px",borderRadius:"10px",backgroundColor:"#fdecb3ff",
                      position:"absolute",top:"1px",right:"1px",cursor:"pointer"
                     }}>
                      <img src='/Assets/data.png' style={{width:"30px"}}/>
                      <p style={{fontSize:"18px",fontWeight:"700"}}>Link</p>
                     </div>}

                    </div>
            ))
            :
            list.map((item)=>(
                <div style={{width:"22vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>
                    <img src={'http://192.168.29.250:7003'+`${item.profile_image}`} style={{height:"70%",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item.first_name}{"  "}{item.last_name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>DOB:{item.dob}</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>Reg:{item.createdAt}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{item.address}</span>
                            </p>
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Contact:{item.primary_number}</p>
                       
                      <p style={{fontSize:"14px",fontWeight:"800"}}>{item.email}</p>
                         
                     </div>

                     <div onClick={()=>{setModal(true);setCurrentUser(item)}}
                     style={{display:"flex",alignItems:"center",padding:"3px",borderRadius:"10px",backgroundColor:"#fdecb3ff",
                      position:"absolute",top:"1px",right:"1px",cursor:"pointer"
                     }}>
                      <img src='/Assets/data.png' style={{width:"30px"}}/>
                      <p style={{fontSize:"18px",fontWeight:"700"}}>Track data</p>
                     </div>

                    </div>
            ))
            }

        </div>

      </section>
      {
        modal && 
        <motion.div 
        initial={{y:150,opacity:1}}
        animate={{y:0,opacity:1}}
        transition={{
          duration:1.3
        }}
        style={{
          height:"90vh",width:"100%",backgroundColor:"white",
          position:"absolute",zIndex:999,top:"200px",padding:"20px",borderRadius:"10px"
        }}
        >
          <div style={{width:"100%",height:"60px",display:"flex",alignItems:"center",justifyContent:"left",gap:"30px",padding:'20px',borderBottom:'1px solid gray',fontSize:'18px',fontWeight:700,cursor:"pointer"}}>
          <p onClick={()=>setModal(false)}>X</p>
          {
          !verified?
          <div style={{display:"flex",alignItems:"center",justifyContent:"left",gap:"20px",padding:"2px 20px",backgroundColor:"#fccfb0ff",borderRadius:"6px"}}>
            <p>Otp sent to patient's email</p>
            <input style={{border:"1px solid gray",borderRadius:"5px",outline:"none",fontSize:"12px",padding:"6px"}}
            placeholder='Enter OTP'
            value={otp} onChange={(e)=>setOtp(e.target.value)}/>
            <p onClick={()=>setVerified(true)}
            style={{cursor:"pointer",padding:"7px",borderRadius:"5px",backgroundColor:"#5b8fffff",fontSize:"12px",fontWeight:"700",color:"white"}}>verify</p>
          </div>
          :
          <p >Tracking data of patient</p>
          }
          
          </div>
          
          <div style={{height:"calc(90vh-60px)",width:"100%",backgroundColor:"#eeeeeeff",minHeight:"calc(90vh-60px)",maxHeight:"calc(90vh-60px)",
            display:"flex",alignItems:"start",justifyContent:"left", transition: "0.3s ease",filter: !verified ? "blur(8px)" : "none", pointerEvents: !verified ? "none" : "auto",
          }}>
             <div style={{width:"22vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>
                   <img src={'http://192.168.29.250:7003'+`${currentUser.profile_image}`} style={{height:"150px",width:"200px",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{currentUser.first_name}{"  "}{currentUser.last_name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>DOB:{currentUser.dob}</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>Reg:{currentUser.createdAt}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{currentUser.address}</span>
                            </p>
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Contact:{currentUser.primary_number}</p>
                       
                      <p style={{fontSize:"14px",fontWeight:"800"}}>{currentUser.email}</p>
                         
                     </div>

                    

                    </div>
            <div style={{width:"70%"}}> 
              <label style={{fontSize:"15px",fontWeight:"700"}}>Upload new Prescription</label>
              <div style={{display:"flex",alignItems:"center",justifyContent:"left",gap:"30px",padding:"20px"}}>
               
                <input placeholder='report type' style={{backgroundColor:"#e2dfdfff",borderRadius:"6px",padding:"4px",width:"150px"}}
                value={report_type} onChange={(e)=>setReport_type(e.target.value)}/>
                <input placeholder='report date'  style={{backgroundColor:"#d8d7d7ff",borderRadius:"6px",padding:"4px",width:"150px"}}
                type='date' value={report_date} onChange={(e)=>setReport_date(e.target.value)}/>
                <input placeholder='report summary'style={{backgroundColor:"#dadadaff",borderRadius:"6px",padding:"4px",width:"150px"}}
                 value={report_summary} onChange={(e)=>setReport_summary(e.target.value)}/>
                <input type='file'style={{backgroundColor:"#afaeaeff",borderRadius:"6px",padding:"4px",width:"150px"}}
                onChange={(e)=>setReport_file(e.target.files[0])}/>

              </div>
              <p onClick={handleUploadReport}
              style={{cursor:"pointer",borderRadius:'6px',padding:'5px',backgroundColor:"#3684f8ff",
                width:"60px",color:"white",fontWeight:"700"
              }}>submit</p>
              
              
              <div style={{display:"flex",alignItems:"center",flexWrap:"wrap",maxHeight:"50vh",height:"50vh",overflowY:"auto"}}>
                        {
                          fileData.map((file)=>(
                            <div style={{padding:"10px",borderRadius:"10px",backgroundColor:"#bbe3fdff",margin:"6px"}}>
                              <img src='/Assets/doc-data.png' style={{width:"180px",height:"220px"}}/>
                              <p style={{fontSize:"13px",fontWeight:"700"}}>Doctor :{file.doc}</p>
                              <p style={{fontSize:"12px",fontWeight:"700"}}>Date:{file.date}</p>
                              </div>
                          ))
                        }

              </div>

            </div>

          </div>

          </motion.div>
      }


    </div>
  )
}

export default Patient
